import firebase from "firebase/app"
import 'firebase/firestore'
import "firebase/analytics";



const config = {
  apiKey: "AIzaSyCppEAbi5i9PqtCd1o_VQeMG4FBWBRsagQ",
  authDomain: "cardiocovid-cb88f.firebaseapp.com",
  databaseURL: "https://cardiocovid-cb88f.firebaseio.com",
  projectId: "cardiocovid-cb88f",
  storageBucket: "cardiocovid-cb88f.appspot.com",
  messagingSenderId: "343995953348",
  appId: "1:343995953348:web:45868bfde85cb7a350d991",
  measurementId: "G-TQBF9D58WC",
};

firebase.initializeApp(config);
export const analytics = firebase.analytics();



const db = firebase.firestore();
export const dbSearch = db;
export const dbGeneralRef = db.collection("general");
export const dbInterventionalRef = db.collection("interventional");
export const dbEpRef = db.collection("ep");
export const dbAdvImgRef = db.collection("advimg");
export const dbAdvHfRef = db.collection("advhf");
export const dbAlgorithmRef = db.collection("algorithm");
export const dbNonCardsRef = db.collection("noncaards");
export const dbOthersRef = db.collection("others");
export const dbAboutRef = db.collection("about");
export const dbHomeRef = db.collection("home");
export const dbCccRef = db.collection("ccc");

export const dbAdvocacyRef = db.collection("advocacy");
export const dbTeamRef = db.collection("team");




